import { removePersistedValue } from 'shared/utils/persisted-values';

export const PBB_REOPEN_PENDING_KEY = 'pbbReopenPending';

export function clearAllPbbReturnState(): void {
  removePersistedValue(PBB_REOPEN_PENDING_KEY, true);
}
